function scroll(to, duration, resolve) {
  const element = document.documentElement.scrollTop ? document.documentElement : document.body,
    difference = to - element.scrollTop,
    perTick = difference / duration * 10

  setTimeout(() => {
    element.scrollTop += perTick

    if (element.scrollTop === to || duration <= 10) {
      resolve()
    } else {
      scroll(to, duration - 10, resolve)
    }
  }, 10)
}

function scrollTo(to, duration) {
  if (!document || !document.body || duration <= 0) {
    return
  }

  return new Promise(resolve => {
    scroll(to, duration, resolve)
  })
}

function bezierScrollTo(to, timeX, timeY, spaceX, spaceY, duration, resolution = 100) {
  if (!document || !document.body || duration <= 0) {
    return
  }

  const element = document.documentElement.scrollTop ? document.documentElement : document.body,
    distance = to - element.scrollTop,
    steps = bezierSteps(distance, timeX, timeY, spaceX, spaceY, duration, resolution)

  element.style.height = `${element.scrollHeight}px`

  return new Promise(resolve => {
    stepScroll(element, steps, resolve)
  })
}

function stepScroll(element, steps, resolve) {
  if (!steps || steps.length == 0) {
    element.style.height = ''

    return resolve()
  }

  const currentStep = steps.pop()

  setTimeout(() => {
    element.scrollTop += currentStep.distance
    stepScroll(element, steps, resolve)
  }, currentStep.time)
}

function bezierSteps(distance, timeX, timeY, spaceX, spaceY, duration, resolution) {
  let steps = [],
    currentStep = 0,
    stepSum = {distance: 0, time: 0}

  while (currentStep < resolution) {
    let stepConfig = interpolateBezier(timeX, timeY, spaceX, spaceY, currentStep / resolution),
      step

    step = {
      stepConfig,
      distance: stepConfig.progression * distance - stepSum.distance,
      time: stepConfig.time * duration - stepSum.time
    }

    steps.push(step)

    stepSum.distance += step.distance
    stepSum.time += step.time

    currentStep++
  }

  return steps
}

function interpolateBezier(timeX, timeY, spaceX, spaceY, t) {
  const p0 = {x: 0, y: 0},
    p1 = {x: timeX, y: timeY},
    p2 = {x: spaceX, y: spaceY},
    p3 = {x: 1, y: 1},
    cX = 3 * (p1.x - p0.x),
    bX = 3 * (p2.x - p1.x) - cX,
    aX = p3.x - p0.x - cX - bX,
    cY = 3 * (p1.y - p0.y),
    bY = 3 * (p2.y - p1.y) - cY,
    aY = p3.y - p0.y - cY - bY,
    x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x,
    y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y

  return {
    time: x,
    progression: y
  }
}

export {scrollTo, bezierScrollTo}
